/* tslint:disable */
/* eslint-disable */
/**
 * Doppio API
 * Microservice backend for ...
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum EarlyRepaymentMethodEnum {
    Never = 'NEVER',
    Anytime = 'ANYTIME',
    AfterSetPeriod = 'AFTER_SET_PERIOD',
    AnytimeWithFee = 'ANYTIME_WITH_FEE',
    AnytimeWithoutInterest = 'ANYTIME_WITHOUT_INTEREST'
}

export function EarlyRepaymentMethodEnumFromJSON(json: any): EarlyRepaymentMethodEnum {
    return EarlyRepaymentMethodEnumFromJSONTyped(json, false);
}

export function EarlyRepaymentMethodEnumFromJSONTyped(json: any, ignoreDiscriminator: boolean): EarlyRepaymentMethodEnum {
    return json as EarlyRepaymentMethodEnum;
}

export function EarlyRepaymentMethodEnumToJSON(value?: EarlyRepaymentMethodEnum | null): any {
    return value as any;
}

